import { useEffect, useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import check from "../../../assets/images/check.svg";
import moreIcon from "../../../assets/images/more.png";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import find from "../../../assets/find.svg";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const EquipListing = () => {
  document.title = "Equipment Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [equipData, setequipData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const itemsPerPage = 6;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [adminStatus, setAdminStatus] = useState("");

  useEffect(() => {
    const equipAdmin = searchParams.get("admin");
    console.log(equipAdmin);
    if (equipAdmin) {
      setAdminStatus(true);
    }
    console.log(adminStatus, "admin status");
  }, [location.search]);

  const gymId = searchParams.get("gymId");
  const { userPermissions, appRole, id } = useSelector(
    (state) => state.auth.currentUser
  );
  console.log(adminStatus, "admin status");
  console.log(
    userPermissions?.equipment?.["Create Equipment"],
    "Create Equipment permission"
  );
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchEquip = async (page, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.equip}?${
          adminStatus == true ? `type=default` : `&gymId=${gymId}`
        }&limit=${itemsPerPage}&page=${page}&search=${searchQuery}`
      );

      setequipData(response.data?.data || []);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching equipment data:", error);
      setequipData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEquip(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm, adminStatus]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSelectChange = async (action, equipId) => {
    switch (action) {
      case "delete":
        await deleteEquip(equipId);
        break;
      case "update":
        const updatedData = {};
        await updateEquip(equipId, updatedData);
        break;

      default:
        break;
    }
  };
  const deleteEquip = async (equipId) => {
    try {
      await del(`${endpoints.equip}/${equipId}`);
      setequipData((prevData) =>
        prevData.filter((equip) => equip.id !== equipId)
      );
      toast.success("Equipment Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchEquip(currentPage);
    } catch (error) {
      console.error("Error deleting equipment:", error);
    }
  };

  const handleEquipDetail = async (equipId) => {
    try {
      const response = await get(`${endpoints.equip}/${equipId}`);
      navigate(`/equip-detail${adminStatus == true ? "?admin=true" : ""}`, {
        state: { equipData: response.data },
      });
    } catch (error) {
      console.error("Error fetching pass details:", error);
    }
  };

  const updateEquip = async (equipId, updatedData) => {
    try {
      await put(`${endpoints.equip}/${equipId}`, updatedData);
      fetchEquip(currentPage, searchTerm);
    } catch (error) {
      console.error("Error updating equip:", error);
    }
  };

  const handleEditequip = (equipId, gymId) => {
    if (!gymId) {
      toast.error("Gym ID is missing. Please check the equipment data.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      return;
    }
    navigate(
      `/edit-equip/${equipId}${adminStatus == true ? "?admin=true" : ""}`
    );
  };

  const toggleDropdown = (equipId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [equipId]: !prevState[equipId],
    }));
  };

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  {/* Title and Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    {/* Title */}
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Equipments
                    </span>

                    {/* Search Bar */}
                    <div
                      className="w-100 w-sm-auto bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{
                        borderRadius: "12px",
                        height: "48px",
                        maxWidth: "400px",
                      }} // Added maxWidth
                    >
                      {/* Search Icon */}
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />

                      {/* Search Input */}
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>
                  {/* Add New Button Section */}
                  {/* {adminStatus == true
                    ? ""
                    : */}
                  {userPermissions?.equipment?.["Create Equipment"] && (
                    <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-xs-0">
                      <Button
                        className="rounded-pill w-auto w-xs-100"
                        style={{ minWidth: "120px" }}
                        onClick={() => {
                          if (adminStatus) {
                            navigate(`/add-equip?admin=true`);
                          } else if (gymId) {
                            navigate(`/add-equip?gymId=${gymId}`);
                          } else {
                            navigate(`/add-equip`);
                          }
                        }}
                      >
                        Add New
                      </Button>
                    </div>
                  )}
                </div>

                <>
                  <div
                    className="table-responsive hide-scrollbar rounded-4"
                    style={{
                      height: equipData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Id
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Equipment
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Category
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Branded
                          </th>
                          <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                            Added on
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : equipData.length === 0 ? (
                          <></>
                        ) : (
                          equipData.map((equip, index) => (
                            <tr key={index}>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      equip?.file == null
                                        ? avatar
                                        : `${process.env.REACT_APP_IMG_URL}${equip?.file}`
                                    }
                                    className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover me-2"
                                    alt={`${equip?.firstName}'s avatar`}
                                  />
                                  <div>
                                    <h6 className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                      {equip?.name}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.category}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip?.brand?.name}
                              </td>
                              <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                                {equip.createdAt
                                  ? new Date(
                                      equip.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                <Dropdown
                                  isOpen={dropdownOpen[equip.id]}
                                  toggle={() => toggleDropdown(equip.id)}
                                  direction="down"
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    {userPermissions?.equipment?.[
                                      "Update Equipment"
                                    ] && (
                                      <DropdownItem
                                        className="fw-normal ff-sora secondary-black font-size-14"
                                        onClick={() =>
                                          handleEditequip(equip.id, equip.gymId)
                                        }
                                      >
                                        Edit Equip
                                      </DropdownItem>
                                    )}
                                    {userPermissions?.equipment?.[
                                      "Delete Equipment"
                                    ] && (
                                      <DropdownItem
                                        className="fw-normal ff-sora secondary-black font-size-14"
                                        onClick={() =>
                                          handleSelectChange("delete", equip.id)
                                        }
                                      >
                                        Delete Equip
                                      </DropdownItem>
                                    )}
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleEquipDetail(equip.id)
                                      }
                                    >
                                      Equip Detail
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {!loading && equipData.length === 0 && (
                      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                        <img
                          src={Placeholder}
                          alt="No record placeholder"
                          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                        />
                        <p className="mt-3 ff-sora font-size-16 fw-normal">
                          No Record Found!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page, index) => (
                    <Button
                      key={page + index}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EquipListing;
